import { createEnum } from './enum.js'

export default createEnum("Right eye", "Left eye", "Both eyes")
